export default "__VITE_ASSET__BeAvH71e__"